<template>
  <div class="container-fluid">
    <div class="row">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1 class="heading-color text-center p-5">Martinelli’s Image Library</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-4" v-if="userRole && category.roles.includes(userRole)" v-for="category in categories" :key="category.label">
            <router-link
              :to="category.link"
              class="sub-heading d-flex justify-content-center"
            >
              <div class="product d-flex justify-content-center align-items-center flex-column">
                <img :src="category.image" alt="" class="img-fluid">
                <h4 class="p-3 ssprm">{{ category.label }}</h4>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  name: 'Home',
  computed: {
    userRole () {
      return this.$store.getters.user.role
    }
  },
  data () {
    return {
      categories: [{
        label: 'Branding & Logos',
        image: '/static/images/brandings.png',
        link: '/branding-and-logos',
        roles: ['admin', 'martinellis']
      }, {
        label: 'Product Categories',
        image: '/static/images/products.png',
        link: '/categories',
        roles: ['admin', 'martinellis']
      }, {
        label: 'Presentation Materials',
        image: '/static/images/presentations.png',
        link: '/presentation-materials',
        roles: ['admin', 'martinellis']
      }, {
        label: 'Photos',
        image: '/static/images/photos.png',
        link: '/photos',
        roles: ['admin', 'martinellis']
      }, {
        label: 'Advertisements',
        image: '/static/images/ads.png',
        link: '/ads',
        roles: ['admin', 'martinellis']
      }, {
        label: 'Sell Sheets',
        image: '/static/images/sell-sheets.png',
        link: '/sell-sheet-categories',
        roles: ['admin', 'martinellis']
      }, {
        label: 'Public Relations',
        image: '/static/images/public-relations.png',
        link: '/public-relations',
        roles: ['admin', 'martinellis']
      }, {
        label: 'Videos',
        image: '/static/images/videos.png',
        link: '/videos',
        roles: ['admin', 'martinellis']
      }, {
        label: '1868',
        image: '/static/images/c1868s.png',
        link: '/1868-categories',
        roles: ['admin', '1868']
      }]
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Home.vue